import { useParams } from "react-router-dom";
import { movies } from "../data/appData";

export default function Player() {
  const { app, mid } = useParams();
  const movie = movies[app].find(m => m.id == mid);

  return (
    <video
      src={movie.video}
      controls
      autoPlay
      style={{
        width: "100%",
        height: "100vh",
        background: "#000"
      }}
    />
  );
}
